import React from "react";
import { Box, Icon, Input, SidebarGroup } from "~/components/UI";
import SelectServiceCategory from "~/components/CommonFormControls/SelectServiceCategory";
import SideBarFilterContainer from "~/components/SideBarFilter/SideBarFilterContainer";
import IncludeFieldGroup from "~/components/SideBarFilter/IncludeFieldGroup";
import { useTranslation } from "react-i18next";

interface FilterProps {
  onChangeFilter: (
    data: IncidentsApi.GetIncidentsQuery
  ) => void | Promise<void>;
}

const Filter = ({ onChangeFilter }: FilterProps) => {
  const { t } = useTranslation();

  return (
    <SideBarFilterContainer onChangeFilter={onChangeFilter}>
      <Box pb={6}>
        <Input
          name="search"
          startAdornment={<Icon name="Lens" />}
          placeholder={t("text.searchByID")}
          fullWidth
          formikControll
        />
        <SidebarGroup
          label={t("label.serviceCategory")}
          collapsed
          defaultOpen={true}
        >
          <SelectServiceCategory name="categoryId" formikControll fullWidth />
        </SidebarGroup>
        <IncludeFieldGroup label={t("table.enabled")} fieldName="enabled" />
        <IncludeFieldGroup
          label={t("title.openedIcidents")}
          fieldName="hasOpenedIncidents"
        />
        <IncludeFieldGroup
          label={t("label.globalCatalog")}
          fieldName="globalCatalog"
        />
      </Box>
    </SideBarFilterContainer>
  );
};

export default React.memo(Filter);
